import { render, staticRenderFns } from "./QuestionModalCardReportOutcome.vue?vue&type=template&id=54597052&scoped=true&"
import script from "./QuestionModalCardReportOutcome.vue?vue&type=script&lang=js&"
export * from "./QuestionModalCardReportOutcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54597052",
  null
  
)

export default component.exports